<template>
  <li class="">
    <router-link :to="link">
      <div class="icon-w">
        <div :class="icon"/>
      </div>
      <span>{{ name }}</span>
    </router-link>
  </li>
</template>
<script>
export default {
	name: 'menu-item',
	props: {
		name: {
			type: String,
			required: true
		},
		icon: {
			type: String,
			required: true
		},
		link: {
			type: String,
			required: true
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/mobile/mainMenu/MenuItem.vue